import { Locale } from 'modules/i18n';

export const translation = {
  [Locale.en]: {
    tvl: 'TVL',
    stakers: 'Stakers',
    apy: 'Total APY',
    epoch: 'Epoch',
  },
};
